import React, { useState } from 'react';
import { RapidLogoSVG } from '../AppMain'; 
import { invokeRapidLoginAPI } from '../api/healthCheckAPI'

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await invokeRapidLoginAPI(username, password);
      
      if (response.success || response.token) {
        
        // Construct user profile objects with safety fallbacks
        const profileUser = {
          name: response.user?.name || username,
          role: response.user?.role || 'user'
        };

        if (response.token) {
          localStorage.setItem('auth_token', response.token);
          localStorage.setItem('auth_user', profileUser.name);
          localStorage.setItem('auth_userrole', profileUser.role);
        }

        // Pass structured information directly to the unified parent loop
        onLogin(profileUser); 
        
      } else {
        setError(response.message || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      setError("Unable to connect to authentication service.");
      console.error("Login component caught error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-logo-row">
          <RapidLogoSVG className="login-rapid-logo" />
          <span className="login-services-portal-text">SERVICES PORTAL</span>
        </div>

        <form onSubmit={handleSubmit} className="login-form-fields">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="login-input"
            disabled={isLoading}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            disabled={isLoading}
            required
          />

          {error && <div className="login-error-message">{error}</div>}

          <button 
            type="submit" 
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? "AUTHENTICATING..." : "LOG IN"}
          </button>
        </form>
      </div>
    </div>
  );
}